module.exports = __webpack_public_path__ + "static/vendor-faq-list-7ccdd89f4e0f1ac05c4901f9bd43aa6c.png";